import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { CheckoutRoutes } from "@jti/fe-common";
import { OrderExceptionCode, useSelector } from "@jti/store";
import { AlertBanner } from "@jti/ui";
import { ShippingDetailsSection } from "../../../../components/ShippingDetailsSection";
import { DeliveryForm } from "../../../../forms/DeliveryForm";
import { useFreeTrial } from "../../../../hooks/useFreeTrial";
import styles from "./DeliveryPageContent.module.scss";
export const DeliveryPageContent = ({ asideSubmitButtonWrapperRef }) => {
    const history = useHistory();
    const { isFreeTrial } = useFreeTrial();
    const { shippingStepData } = useSelector((state) => state.standardCheckoutForm);
    const { error: checkoutError } = useSelector((state) => state.checkout);
    const checkoutErrorMessage = checkoutError.visible &&
        checkoutError.exception?.code === OrderExceptionCode.MagentoOrderCreationIssue &&
        checkoutError.exception?.message;
    const addresses = shippingStepData
        ? {
            shippingAddress: shippingStepData.shippingAddress,
            billingAddress: shippingStepData.billingAddress,
        }
        : undefined;
    const goToShippingStep = () => {
        const shippingPageUrl = new CheckoutRoutes({ isFreeTrial }).shipping;
        history.push(shippingPageUrl);
    };
    useEffect(() => {
        if (checkoutErrorMessage) {
            scrollTo(0, 0);
        }
    }, [checkoutErrorMessage]);
    return (_jsxs(_Fragment, { children: [checkoutErrorMessage && (_jsx("div", { className: styles.errorBanner, children: _jsx(AlertBanner, { variant: "error", description: checkoutErrorMessage, withIconClose: false }) })), _jsx(ShippingDetailsSection, { shippingAddress: addresses?.shippingAddress, companyName: shippingStepData?.shippingAddress.pickupInformation?.name, onEdit: goToShippingStep, className: styles.shippingDetailsSection, isEditButtonAvailable: true }), _jsx(DeliveryForm, { asideSubmitButtonWrapperRef: asideSubmitButtonWrapperRef })] }));
};
//# sourceMappingURL=DeliveryPageContent.js.map